<template>
  <article class="example-page">
    <h1>Side Menu</h1>
    <form>
      <label for="menu-content">Menu Content</label>
      <textarea id="menu-content" v-model="contentData" placeholder="Content" />
      <button type="button" @click="toggle">Toggle</button>
    </form>

    <side-menu :opened="openedData" @close="toggle">
      <!-- eslint-disable vue/no-v-html -->
      <div v-if="contentData !== ''" slot="content" v-html="contentData" />
      <!-- eslint-enable -->
    </side-menu>
  </article>
</template>

<script>
import '@/lib/icons/signout';
import { sideMenu } from '@/components/layout';

export default {
  components: { 'side-menu': sideMenu },
  data() {
    return {
      openedData: false,
      contentData:
`<ul class="side-menu-content">
  <li><a href="#">Account</a></li>
  <li><a href="#">Password</a></li>
  <li><a href="#">Revenue</a></li>
  <li><hr></li>
  <li><a href="#">Support</a></li>
  <li><a href="#">FAQ</a></li>
  <li><hr></li>
  <li><a href="#" class="coloured-link">
    <svg version="1.1" viewBox="0 0 32 32" class="signout-icon svg-icon svg-fill" alt="${this.$t('Sign out')}" style="width: 1.4rem; height: 1.4rem;">
      <path pid="0" d="M20.8 7.5l-1.5 1.4 6.1 6.1H7v2h18.4l-6.1 6.1 1.5 1.4 8.5-8.5z"></path><path pid="1" d="M4 5h4V3H2v26h6v-2H4z"></path>
    </svg>
    Sign Out
  </a></li>
</ul>`,
    };
  },
  methods: {
    toggle() {
      this.openedData = !this.openedData;
    },
  },
};
</script>
